import { render, staticRenderFns } from "./GoalSetter.vue?vue&type=template&id=434b938a&lang=pug&"
import script from "./GoalSetter.vue?vue&type=script&lang=js&"
export * from "./GoalSetter.vue?vue&type=script&lang=js&"
import style0 from "./GoalSetter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports